import { getWeekDay } from './time.util';
import { WEEK_DAYS } from '../constants/time.constants';
import { TICKERS_CATEGORIES } from '../constants/tickers.constants';

export const matchSymbol = (word, symbol, fancySymbol) => {
  if (!word) return true;
  const wordUpper = word.toUpperCase();
  return (
    symbol.search(wordUpper) !== -1 || fancySymbol.search(wordUpper) !== -1
  );
};
export const getNow = () => +new Date();

export const calcChange = (tick, candle) => {
  if (!tick || !candle) return 0;
  return 100 * (1 - (tick.ask + tick.bid) / 2 / +candle.close);
};
export const filterTickers = ({ data, category, word }) =>
  data
    .filter((i) => i.categories.includes(category))
    .filter((i) => matchSymbol(word, i.symbol, i.fancySymbol));
export const parseTradingSessionTime = (time) => {
  if (time.includes('24:00')) time = time.replace('24:00', '23:59:59');
  const now = new Date().toUTCString();
  const reg = /\d{4}/;
  const delimiter = reg.exec(now)[0];
  const firstPart = now.split(delimiter)[0];
  return Date.parse(`${firstPart}${delimiter} ${time.replace('-', '+')}`);
};

export const isCloseDateForSymbol = (instruments, symbol) => {
  if (!instruments) return true;
  const currentInstrument = Array.isArray(instruments)
    ? instruments.find((i) => i.symbol === symbol)
    : instruments;
  if (!currentInstrument) return true;

  const { sessions } = currentInstrument;

  const tradingSchedule = sessions[getWeekDay()].trade[0];

  if (!tradingSchedule?.open || !tradingSchedule?.close) return true;

  const from = parseTradingSessionTime(tradingSchedule?.open);
  const to = parseTradingSessionTime(tradingSchedule?.close);
  const now = +new Date();

  const isTraded = now > from && now < to;
  return !isTraded;
};

export const findClosestTradingSession = (instruments, symbol) => {
  const { sessions } = instruments.find((i) => i.symbol === symbol);

  const findTime = (weekDay) => {
    const schedule = sessions[weekDay];
    const { trade } = schedule;
    if (trade.length === 0) {
      let newDayIndex = WEEK_DAYS.indexOf(weekDay) + 1;
      if (newDayIndex === WEEK_DAYS.length) newDayIndex = 0;
      return findTime(WEEK_DAYS[newDayIndex]);
    }
    const [{ open }] = trade;
    const formatted = open.replace('-', '+');
    if (weekDay !== getWeekDay()) {
      return `${weekDay} ${formatted}`;
    }
    return formatted;
  };

  return findTime(getWeekDay());
};

export const findTradingSessionForTV = (sessions) => {
  const schedule = sessions[getWeekDay()];
  const { quote } = schedule;
  if (quote.length === 0) return '';
  const [{ open, close }] = quote;
  const [f1] = open.split(' ');
  const [f2] = close.split(' ');
  return `${f1}-${f2}`.replaceAll(':', '');
};

export const findSymbolCategory = (symbol) => {
  let mut = symbol;
  if (mut.includes('.')) {
    [mut] = mut.split('.');
  }
  const ct = Object.keys(TICKERS_CATEGORIES)
    .slice(1)
    .filter((c) => TICKERS_CATEGORIES[c].symbols.includes(mut));

  return ct[0]?.toLowerCase();
};
